module.exports = __webpack_public_path__ + "static/media/drb.1ba6ffc9.jpeg";